import { PostHogEventEnum, type IntegrationConnectType } from '@/Domain/enum/PostHogEvent.enum';

type CaptureFn = (event: PostHogEventEnum, properties?: Record<string, unknown>) => void;

// Pure emitters for the unified cross-channel connect funnel, parameterized by
// `capture` so they work the same from a component, an OAuth-callback listener,
// or a plain module function. See PostHogEvent.enum.ts for the event contract.
export const trackIntegrationConnectStarted = (
  capture: CaptureFn,
  integrationType: IntegrationConnectType,
  properties?: Record<string, unknown>,
): void =>
  capture(PostHogEventEnum.IntegrationConnectStarted, {
    integration_type: integrationType,
    ...properties,
  });

export const trackIntegrationConnectSucceeded = (
  capture: CaptureFn,
  integrationType: IntegrationConnectType,
  properties?: Record<string, unknown>,
): void =>
  capture(PostHogEventEnum.IntegrationConnectSucceeded, {
    integration_type: integrationType,
    ...properties,
  });

export const trackIntegrationConnectFailed = (
  capture: CaptureFn,
  integrationType: IntegrationConnectType,
  reason: string,
  properties?: Record<string, unknown>,
): void =>
  capture(PostHogEventEnum.IntegrationConnectFailed, {
    integration_type: integrationType,
    reason,
    ...properties,
  });
